// extracted by mini-css-extract-plugin
export default {"header":"styles_header__nmmZO","title":"styles_title__dkw9l","switchContainer":"styles_switchContainer__e67VJ","text":"styles_text__jGOIy","row":"styles_row__zfIQK"};